
  var _styles = {
  "component-wrapper": {
    "width": "100%",
    "paddingTop": "0.16rem",
    "paddingRight": "0.32rem",
    "paddingBottom": "0.16rem",
    "paddingLeft": "0.32rem",
    "display": "flex",
    "flexDirection": "column",
    "alignItems": "center",
    "marginTop": "0.66667rem"
  },
  "component-wrapper-text": {
    "fontSize": "0.64rem"
  },
  "component-div-three": {
    "width": "100%",
    "display": "flex",
    "flexDirection": "row",
    "flexWrap": "wrap",
    "boxSizing": "border-box",
    "justifyContent": "flex-start",
    "alignItems": "center"
  },
  "component-div-three-columns": {
    "width": "3.01333rem",
    "display": "flex",
    "justifyContent": "center",
    "alignItems": "center"
  },
  "component-wrapper-double": {
    "paddingTop": "0.16rem",
    "paddingRight": "0.32rem",
    "paddingBottom": "0.16rem",
    "paddingLeft": "0.32rem",
    "width": "100%",
    "display": "flex",
    "flexDirection": "column"
  },
  "component-wrapper-double_more-btn": {
    "width": "2.24rem",
    "height": "0.8rem"
  },
  "component-div": {
    "display": "flex",
    "flexDirection": "row",
    "flexWrap": "wrap",
    "boxSizing": "border-box",
    "justifyContent": "space-between"
  },
  "component-wrapper-horizontal": {
    "width": "100%",
    "padding": "0.16rem",
    "boxSizing": "border-box",
    "display": "flex",
    "flexDirection": "row",
    "justifyContent": "center",
    "alignItems": "center"
  },
  "component-wrapper-horizontal_more-btn": {
    "width": "2.24rem",
    "height": "0.8rem",
    "justifySelf": "center"
  },
  "more-btn": {
    "pointerEvents": "auto",
    "width": "2.66667rem",
    "height": "0.86667rem",
    "marginTop": "0.16rem",
    "marginBottom": "0.08rem"
  },
  "component-empty-state": {
    "width": "100%",
    "fontSize": "0.4rem",
    "display": "flex",
    "alignItems": "center"
  }
};



  module.exports = _styles;
  